import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { EditTabModel, EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { BusinessUnitInvoiceInformationModel } from '../business-unit-invoice-information.model';
import { AppTextService } from '@fi-shared/app-text';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { BillingService } from '../../billing.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { fiInvoiceMethodType } from '@fi-app/customer-billing/customer-billing-invoice/invoice-method-type';
import { BillingContactUsingType } from '../../billing-contact-type';
import { DropdownSettingsModelV2 } from '@fi-shared/dropdown';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { IContentLanguage } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { INameIdObj } from '@fi-shared/fi-shared-interfaces';
import { FiCustomValidatorPatterns } from '@fi-shared/fi-custom-validator-patterns/fi-custom-validator-patterns';

@Component({
    selector: 'fi-business-unit-invoice-information-edit',
    templateUrl: './business-unit-invoice-information-edit.component.html',
    styleUrls: ['./business-unit-invoice-information-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-business-unit-invoice-information-edit' },
    standalone: false,
})
export class BusinessUnitInvoiceInformationEditComponent implements OnInit {
    @Input() invoiceInformation: BusinessUnitInvoiceInformationModel;

    invoiceMethodType = fiInvoiceMethodType;
    contactsUsingType = BillingContactUsingType.Reference;
    invoiceLanguageListData = new DropdownSettingsModelV2<IContentLanguage>({
        filterBy: 'Name',
    });
    invoiceCurrencyListData = new DropdownSettingsModelV2<INameIdObj>({
        filterBy: 'Name',
    });
    editTabs: EditTabsModel;
    FiCustomValidatorPatterns = FiCustomValidatorPatterns;

    constructor(
        private appTextService: AppTextService,
        private saveChangesWarningService: SaveChangesWarningService,
        private fiLoadingService: LoadingService,
        private billingService: BillingService,
        private stateService: FiStateService,
        private contentLanguages: ContentLanguagesService,
    ) {}

    ngOnInit() {
        this.setSelectsDataSets();
        this.setPageHeaderData();
        this.saveChangesWarningService.start(() => this.invoiceInformation);
    }

    private setPageHeaderData() {
        this.editTabs = new EditTabsModel(this.appTextService.get('billing.edit_invoice_info'));
        this.editTabs.Tabs.push(
            new EditTabModel(this.appTextService.get('common.general'), this.appTextService.get('common.general')),
        );
    }

    private setSelectsDataSets() {
        this.invoiceLanguageListData.setDataSet(this.contentLanguages.GetApplicationLanguages());
        this.invoiceCurrencyListData.setDataSet(this.billingService.GetBillingCurrencies());
    }

    isCurrentInvoiceMethod(invoiceMethodType: fiInvoiceMethodType): boolean {
        return this.invoiceInformation.InvoiceMethodType === invoiceMethodType;
    }

    save() {
        this.fiLoadingService
            .trackPromise(this.billingService.SaveBusinessUnitPaymentInformation(this.invoiceInformation))
            .then(() => {
                this.saveChangesWarningService.stop();
                this.stateService.go(FiStateNames.Billing.Payment.List);
            });
    }
}
